export interface ApiFilter {
  [key: string]: string;
}

export interface ApiSort {
  [key: string]: 'asc' | 'desc';
}

export const GetQueryParam = (filter?: ApiFilter, sort?: ApiSort) => {
  let qp = '';
  if (filter) {
    Object.keys(filter).forEach((key) => {
      if (filter[key]) {
        qp += qp ? `&${ key }=${ filter[key] }` : `${ key }=${ filter[key] }`;
      }
    });
  }
  if (sort) {
    Object.keys(sort).forEach((key) => {
      qp += qp ? `&sort=${ key },${ sort[key] }` : `sort=${ key },${ sort[key] }`;
    });
  }
  return qp;
};
